import { useCallback } from 'react';
import type { LatLng } from '~/_shared/types/latLng';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { useActiveDrawingInstanceZIndex } from '~/map/zIndexes/useDrawingInstanceZIndex.hook';
import { useShapeDrawStateSelector } from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.selectors';
import {
  ShapeDrawConfiguration, ShapeDrawShape,
} from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.state';
import { useProximityToolSelector } from '~/store/frontendState/proximityTool/proximityTool.selectors';
import { useMapSettingsSettingsUnitSystemSelector } from '~/store/mapSettings/settings/mapSettingsSettings.selectors';
import { MapCircleDrawContainer } from '../mapObjects/mapCircle/mapCircleDraw.container';
import { shapeDrawCircleParamsSelector } from './shapeDrawCircle.selectors';
import { useShapeDrawCircleProps } from './useShapeDrawCircleProps';
import { useShapeDrawFinished } from './useShapeDrawFinished';

export const ShapeDrawOverlay = () => {
  const shapeDrawState = useShapeDrawStateSelector();
  const { processDrawnItem } = useShapeDrawFinished();
  const zIndex = useActiveDrawingInstanceZIndex();
  const globalUnitSystem = useMapSettingsSettingsUnitSystemSelector();
  const unitSystemProximityTool = useProximityToolSelector().unit;

  const unitSystem = shapeDrawState.configuration === ShapeDrawConfiguration.CreateIndividualProximity
    ? unitSystemProximityTool : globalUnitSystem;

  const onCircleDrawn = useCallback((params: { center: LatLng; radiusInPixels: number; radiusInMeters: number }) => {
    processDrawnItem({ circle: params });
  }, [processDrawnItem]);

  const circleRenderParams = useSelector(shapeDrawCircleParamsSelector);
  const mapDrawCircleProps = useShapeDrawCircleProps(circleRenderParams);

  if (!shapeDrawState.isActive) {
    return null;
  }

  if (shapeDrawState.shape === ShapeDrawShape.Circle) {
    return (
      <MapCircleDrawContainer
        {...mapDrawCircleProps}
        zIndex={zIndex}
        onCircleDrawn={onCircleDrawn}
        unitSystem={unitSystem}
        showDistanceFromCenterToCursor
      />
    );
  }

  return null;
};
